module.exports = __webpack_public_path__ + "img/Manila Bay Cleanup Drive 2.8ba7d45a.jpg";